<script setup lang="ts">
import { useAccount } from '../model/useAccount'

withDefaults(
  defineProps<{
    title?: string
    transparent?: boolean
  }>(),
  { title: 'Admin Settings', transparent: false }
)

const { isStaff } = useAccount()
</script>

<template>
  <template v-if="isStaff">
    <slot v-if="transparent" />

    <section v-else class="admin-block">
      <h3 class="admin-block__title">{{ title }}</h3>
      <slot />
    </section>
  </template>
</template>

<style lang="scss" scoped>
.admin-block {
  padding: 12px 16px;
  background-color: var(--el-fill-color);
  border-radius: 8px;
}

.admin-block__title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
}
</style>
